module.exports = __webpack_public_path__ + "img/bgc.png";